import React, { useEffect } from 'react'
import styles from 'components/quests/confirm.module.scss'

export default function Confirm({ modalParams, closeModal }) {
    const onConfirm = () => {
        closeModal()
        if (modalParams.onConfirm) modalParams.onConfirm()
    }

    const onCancel = () => {
        closeModal()
        if (modalParams.onCancel) modalParams.onCancel()
    }

    const renderIcon = () => {
        if (modalParams.iconType === 'image-gen') {
            return (
                <img
                    src="/assets/images/image-gen.jpeg"
                    alt="Image Generation Icon"
                    className={styles.confirmIcon}
                />
            )
        } else if (modalParams.iconType === 'video-gen') {
            return (
                <img
                    src="/assets/images/video-gen.jpeg"
                    alt="Video Generation Icon"
                    className={styles.confirmIcon}
                />
            )
        }
        return null
    }

    const renderMessage = () => {
        // If message is a React element, return it directly
        if (React.isValidElement(modalParams.message)) {
            return modalParams.message
        }
        // Otherwise treat it as a string
        return <div>{modalParams.message}</div>
    }

    useEffect(() => {
        const handleKeyDown = event => {
            if (event.key === 'Enter') {
                onConfirm()
            } else if (event.key === 'Escape') {
                onCancel()
            }
        }

        window.addEventListener('keydown', handleKeyDown)
        return () => {
            window.removeEventListener('keydown', handleKeyDown)
        }
    }, [modalParams])

    return (
        <div className={styles.confirmComp}>
            <div className={styles.confirmHeader}>{renderIcon()}</div>
            <div className={styles.confirmMessageContainer}>{renderMessage()}</div>
            <div className={styles.confirmActions}>
                {!modalParams.hideCancel && (
                    <button className={styles.cancelButton} onClick={onCancel}>
                        {modalParams.cancelMessage || 'Cancel'}
                    </button>
                )}

                <button className={styles.confirmButton} onClick={onConfirm}>
                    {modalParams.confirmLabel || 'Got it!'}
                </button>
            </div>
        </div>
    )
}
